import React, {useContext, useEffect, useState} from "react";
import {AuthContext} from "./AuthContext";
import {getParametriApi} from "../features/impostazioni/services/ParametriServices";

export const ParametersContext = React.createContext(0);

export const ParametersProvider = ({value, children}) => {

    const [parameters, setParameters] = useState({});
    const [parametersList, setParametersList] = useState([]);
    const [reset, setReset] = useState(false);
    const [updateParameterCount, setUpdateParameterCount] = useState(0);
    const [loading, setLoading] = useState(true);

    const {isLogged} = useContext(AuthContext);

    async function fetchParams() {
        let parametersMap = await getParams();
        setParameters(parametersMap);
        setUpdateParameterCount(updateParameterCount + 1);
        setLoading(false);
    }

    async function getParams() {
        const response = await getParametriApi();
        let pars = response.data.data;
        setParametersList(pars);

        let parametersMap = {};
        pars.forEach(p => parametersMap[p.codice] = p.valore);
        return parametersMap;
    }

    useEffect(() => {
        if (isLogged() && loading === true) {
            fetchParams();
        }
    }, [isLogged]);

    useEffect(() => {
        if (isLogged() && loading === false) {
            fetchParams();
        }
    }, [reset]);

    const getParameterValue = async function (paramCode) {
        if (parameters && Object.keys(parameters).length > 0) {
            return parameters[paramCode]
        } else {
            console.warn('Cache parametri vuota');
            let pars = await getParams();
            return pars[paramCode]
        }
    }

    const getParameters = function () {
        return parametersList
    }

    const resetParameters = function () {
        setReset(!reset);
    }

    return (
        <ParametersContext.Provider
            value={{
                getParameterValue,
                resetParameters,
                getParameters,
                updateParameterCount,
            }}>{children}</ParametersContext.Provider>
    );
};
